module.exports = __webpack_public_path__ + "img/kushi_beer.3fec552b.jpg";